import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiActivity, FiPhone, FiMail, FiMapPin, FiExternalLink } = FiIcons;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Reviews', path: '/reviews' },
    { name: 'Contact Us', path: '/contact' }
  ];

  return (
    <footer className="bg-black border-t border-yellow-500/20">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <motion.div
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="lg:col-span-2"
          >
            <Link to="/" className="flex items-center space-x-2 mb-4">
              <div className="bg-gradient-to-r from-yellow-400 to-yellow-600 p-2 rounded-full">
                <SafeIcon icon={FiActivity} className="text-black text-xl" />
              </div>
              <span className="text-xl font-bold bg-gradient-to-r from-yellow-400 to-yellow-600 bg-clip-text text-transparent">
                Body Fitness Cers
              </span>
            </Link>
            <p className="text-gray-400 leading-relaxed mb-6">
              A premium fitness center with state-of-the-art equipment and a welcoming, 
              family-oriented atmosphere. Join our community and experience the difference.
            </p>
            <div className="space-y-2">
              <div className="flex items-center space-x-3 text-gray-400">
                <SafeIcon icon={FiPhone} className="text-yellow-500" />
                <span>+33670314372</span>
              </div>
              <div className="flex items-center space-x-3 text-gray-400">
                <SafeIcon icon={FiMail} className="text-yellow-500" />
                <span>info@bodyfitnesscers.com</span>
              </div>
              <div className="flex items-center space-x-3 text-gray-400">
                <SafeIcon icon={FiMapPin} className="text-yellow-500" />
                <span>Premium Fitness Center</span>
              </div>
            </div>
          </motion.div>

          {/* Quick Links */}
          <motion.div
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}
          >
            <h3 className="text-xl font-bold text-white mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-yellow-500 transition-colors duration-300"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Hours */}
          <motion.div
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <h3 className="text-xl font-bold text-white mb-4">Hours</h3>
            <div className="space-y-2 text-gray-400">
              <div className="flex justify-between">
                <span>Monday - Friday:</span>
                <span>24/7</span>
              </div>
              <div className="flex justify-between">
                <span>Saturday:</span>
                <span>24/7</span>
              </div>
              <div className="flex justify-between">
                <span>Sunday:</span>
                <span>24/7</span>
              </div>
              <div className="mt-4 p-3 bg-yellow-500/10 rounded-lg border border-yellow-500/20">
                <p className="text-yellow-500 font-semibold">
                  24/7 Access for Members
                </p>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Bottom Section */}
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
          className="border-t border-yellow-500/20 mt-12 pt-8"
        >
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-center md:text-left">
              © {currentYear} Body Fitness Cers. All rights reserved.
            </p>
            <p className="text-gray-400 text-center md:text-right">
              Domain + Hosting + Design = 
              <a 
                href="https://www.account4web.ca" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-yellow-500 hover:text-yellow-400 transition-colors duration-300 ml-1 inline-flex items-center gap-1"
              >
                Account4Web Inc
                <SafeIcon icon={FiExternalLink} className="text-xs" />
              </a>
            </p>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;